import store from '../state/store'
import 'whatwg-fetch'
import {stringifyURLParams} from '../lib/url'

export default {
  methods: {
    translate (key, args) {
      if (store.state.translations[key]) {
        return this.getTranslation(key, args);
      } else {
        // fetch the translation from rails if it's not already pending
        if (store.state.translations[key] !== null) {
          // set our pending state with null (not undefined)
          store.dispatch('setTranslation', {
            key,
            value: null,
          })

          fetch(`/translation?${stringifyURLParams({key: key})}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            },
          }).then(response => {
            response.json().then(data => {
              store.dispatch('setTranslation', {
                key,
                value: data.result,
              })

              // i don't love this but because we're calling a function
              // instead of using native reactivity,
              // we need to  manually re-render after getting the data
              this.$forceUpdate();
            })
          }, (error) => {
            console.error(error.message)
          })
        }

        return ''
      }
    },

    getTranslation(key, args) {
      let translation = store.state.translations[key]

      if (args) { // replace dynamic text
        Object.keys(args).forEach(key => {
          const regex = new RegExp(`\%\{${key}\}`, 'gi')
          translation = translation.replace(regex, args[key])
        })
      }

      return translation
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/mixins/translation.js